import { Injectable } from "@angular/core";
import { map, catchError } from "rxjs/operators";

import { forkJoin, throwError, of } from "rxjs";

import { HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
import {
  HttpClientService,
  AdobeAnalyticsService,
  UtilityService,
} from "lib/ng2-sapmp/src/providers";
import { ANALYTICS_CONSTANTS } from "config";
import * as FileSaver from "file-saver";
declare var ENV_PORTAL;
// declare module "file-saver";
// import { saveAs } from 'file-saver';
@Injectable()
export class ManageDashboardService {
  constructor(
    private http: HttpClient,
    private httpClientService: HttpClientService,
    private adobeAnalyticsService: AdobeAnalyticsService,
    private utilityService: UtilityService
  ) { }

  get_headers() {
    let headers = new HttpHeaders();
    headers = headers.append(
      "Authorization",
      sessionStorage.getItem("sapmp_jwtToken")
    );
    return headers;
  }

  fetchJSON(dataurl) {
    return this.httpClientService.get(dataurl, this.get_headers()).pipe(
      map((res: HttpResponse<any>) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(
            this.utilityService.getEnvConfig().tokenRefresh
          );
        }
        return res.body;
      }),
      catchError(this.handleError)
    );
  }

  // dashboardProducts(manageDashboardUrl) {
  //   return this.httpClientService.authorizedGet(manageDashboardUrl)
  //     .map((res: Response) => {
  //     if (sessionStorage.getItem('sapmp_jwtToken') != null) {
  //       // refreshes token for logged in scenario upon page load
  //       this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
  //     }
  //    return res.json();})
  //     .catch(this.handleError);
  // }
  // ------------------------------------ ForkJoin Start--------------------------------------------------//

  dashboardData(productUrl, donutUrl) {
    let resp = [{}, {}, {}];
    return forkJoin(
      this.httpClientService.authorizedGet(productUrl).pipe(
        map((res: HttpResponse<any>) => (resp[0] = res.body)),
        catchError(() => of([]))
      ),
      this.httpClientService.authorizedGet(donutUrl).pipe(
        map((res: HttpResponse<any>) => (resp[1] = res.body)),
        catchError(() => of([]))
      )
    ).pipe(
      map((resp: [HttpResponse<any>, HttpResponse<any>]) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          this.httpClientService.tokenRefresh(
            this.utilityService.getEnvConfig().tokenRefresh
          );
        }
        return resp;
      }),
      catchError(this.handleError)
    );
  }

  // ------------------------------------ ForkJoin End--------------------------------------------------//

  searchUserService(searchUrl, value) {
    return this.httpClientService.authorizedPut(searchUrl, value).pipe(
      map((res: HttpResponse<any>) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(
            this.utilityService.getEnvConfig().tokenRefresh
          );
        }
        return res.body;
      }),
      catchError(this.handleError)
    );
  }

  // dashboardDonut(manageDashboardUrl) {
  //   return this.httpClientService.authorizedGet(manageDashboardUrl)
  //   .map((res: Response) => {
  //     if (sessionStorage.getItem('sapmp_jwtToken') != null) {
  //       // refreshes token for logged in scenario upon page load
  //       this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
  //     }
  //    return res.json();})
  //     .catch(this.handleError);
  // }

  handleError = (error) => {
    return throwError(error);
  };

  dashboardReport(reportUrl, type) {
    let headers = new HttpHeaders();
    let responseType: any;
    headers = headers.append("PermType", "userSummaryReport.download");
    if (type === "csv") {
      headers = headers.append("FileType", "csv");
      responseType = "text";
    } else {
      headers = headers.append("FileType", "xlsx");
      responseType = "blob";
    }
    return (
      this.httpClientService
        .authorizedOctetget(reportUrl, headers, responseType)
        .subscribe((response: HttpResponse<any>) => {
          console.dir(response);
          if (sessionStorage.getItem("sapmp_jwtToken") != null) {
            // refreshes token for logged in scenario upon page load
            this.httpClientService.tokenRefresh(
              this.utilityService.getEnvConfig().tokenRefresh
            );
          }
          this.downloadFile(response.body, type);
        }),
      (error) => {
        this.handleError(error);
      }
    );
  }

  downloadFile(data: HttpResponse<any>, types) {
    const a: any = document.createElement("a");
    let mimeType: any = "";
    let blob;
    document.body.appendChild(a);
    a.style.cssText = "display: none";
    const res: any = data;
    if (types === "csv") {
      a.download = "report.csv";
      mimeType = "text/csv";
      blob = new Blob([res], { type: mimeType });
    } else {
      a.download = "report.xlsx";
      mimeType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      blob = new Blob([res], { type: mimeType });
    }
    FileSaver.saveAs(blob, a.download);
  }

  checkLength(data) {
    const str = data.value.toString();
    if (str.trim()) {
      if (str.replace(" ", "").length < 3) {
        return {
          length: true,
        };
      }
    }
  }

  createPageLoadProperties(url: string, header: string) {
    const dataLayer = {};
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] =
      ANALYTICS_CONSTANTS.FRIENDLY_NAME_DASHBOARD;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] =
      ANALYTICS_CONSTANTS.FLOW_CODE_DASHBOARD;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SKU] = "";
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = "home";
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = "Service";
    this.adobeAnalyticsService.tag("page", dataLayer, "Page_Load", "pageLoad");
  }

  // ADDP section goes here
  getFanStatusSummary(companyId) {
    // will be calling actual api with company id;
    let apiUrl;

    apiUrl = this.utilityService.getEnvConfig().dashboardSummary;
    //apiUrl = "assets/mock/dashboard/setupOemCompleted.json";
    // apiUrl = "assets/mock/dashboard/getFANLIstMock5.json";

    return this.httpClientService.get(apiUrl, this.get_headers()).pipe(
      map((res: HttpResponse<any>) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(
            this.utilityService.getEnvConfig().tokenRefresh
          );
        }
        return res.body;
      }),
      catchError(this.handleError)
    );
  }
  getFanDetails() {
    let apiUrl;
    apiUrl = this.utilityService.getEnvConfig().dashboardSummary;
    return this.httpClientService.get(apiUrl, this.get_headers()).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  getDevicesCount(companyId) {
    let apiUrl;

    apiUrl = this.utilityService.getEnvConfig().deviceCountSummary;
    //apiUrl = "assets/mock/dashboard/setupOemCompleted.json";
    // apiUrl = "assets/mock/dashboard/getFANLIstMock5.json";

    return this.httpClientService.get(apiUrl, this.get_headers()).pipe(
      map((res: HttpResponse<any>) => res.body),
      catchError(this.handleError)
    );
  }

  getDeviceStatusSummary(url, req) {
    // will be calling actual api with request;
    return this.httpClientService.get(url, this.get_headers()).pipe(
      map((res: HttpResponse<any>) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(
            this.utilityService.getEnvConfig().tokenRefresh
          );
        }
        return res.body;
      }),
      catchError(this.handleError)
    );
  }

  getDashboardContent(url) {
    // will be calling actual api with request;
    return this.httpClientService.get(url).pipe(
      map((res: HttpResponse<any>) => {
        if (sessionStorage.getItem("sapmp_jwtToken") != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(
            this.utilityService.getEnvConfig().tokenRefresh
          );
        }
        return res.body;
      }),
      catchError(this.handleError)
    );
  }

  getAppleSummary() {
    let appleUrl;
    appleUrl =
      this.utilityService.getEnvConfig().getAppleSummary + "?detail=false";
    return this.fetchJSON(appleUrl);
  }

  getFANList() {
    let fanUrl;
    fanUrl = this.utilityService.getEnvConfig().getFANList;
    return this.fetchJSON(fanUrl);
  }
}
